import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { EXPENSE_SURVEY_CONSTANTS } from '../../constants/app-constants';

@Component({
  selector: 'confrimation-box',
  templateUrl: 'confirmation-box.component.html',
  styleUrls: ['confirmation-box.component.scss'],
})
export class ConfirmationBoxComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() submessage: string;
  @Input() projectCSS: boolean = false;
  @Output() confirmBoxHandler: EventEmitter<boolean> = new EventEmitter<boolean>();
  isSurveyCancelModal: boolean = false;

  constructor() { }

  ngOnInit() {
    if (this.message === EXPENSE_SURVEY_CONSTANTS.CANCEL_SURVEY_CREATION) {
      this.isSurveyCancelModal = true;
    }
  }

  closeConfirmationBox(status: boolean) {
    this.confirmBoxHandler.emit(status);
  }
}
